import { createContext } from "react";

export const docUploadRefreshContext = createContext();
export const CaseContext = createContext();
export const CaseStageContext = createContext(null);
